export default __webpack_public_path__ + "static/media/WS_black_logo.e1b66f07.svg";